import { useEffect, useState } from 'react';
import { Container } from './styled';
import { Chat, ChatPreview, Intro, VideoCall } from '../../components';
import { useChat } from '../../contexts/chat';
import { monitoringStatusUser } from '../../service/serviceChat/chatService';


const CHAT_MODE = {
    DEFAULT: 0,
    EXPANDED: 1,
    COLLAPSED: 2,
};

export function Window() {

    const { idChat, nameClientInChat, render, customer, resetChat } = useChat();
    const [dataCustomer, setDataCustomer] = useState(null);
    const [chatMode, setChatMode] = useState(CHAT_MODE.EXPANDED);
    const parsedRender = parseInt(render);

    useEffect(() => {
        monitoringStatusUser();
    }, []);
    useEffect(() => {
        if (typeof customer !== 'string') return setDataCustomer(customer);
        return setDataCustomer(JSON.parse(customer));
    }, [customer]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.code === 'Escape') {
                resetChat();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [resetChat]);

    const onToggleChatMode = (isOpenMenu) => {
        setChatMode(isOpenMenu ? CHAT_MODE.COLLAPSED : CHAT_MODE.EXPANDED);
    };
    
    return (
        <Container>
            <VideoCall
                refWindow={idChat}
                mode={(!idChat || parsedRender === 3) ? CHAT_MODE.DEFAULT : chatMode}
            />
            {!idChat ? (
                <Intro />
            ) : parsedRender === 1 ? (
                <Chat
                    idChat={idChat}
                    nameClient={nameClientInChat}
                    customer={dataCustomer}
                    onToggleChatMode={onToggleChatMode}
                />
            ) : parsedRender === 3 ? (
                <Intro />
            ) : (
                <ChatPreview
                    idChat={idChat}
                    nameClient={nameClientInChat}
                    customer={dataCustomer}
                    parsedRender={parsedRender}
                    onToggleChatMode={onToggleChatMode}
                />
            )}
        </Container>
    );
}